import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import zhLocale from '@fullcalendar/core/locales/zh-cn';
import interactionPlugin from '@fullcalendar/interaction';
import commonMixin from "./common-mixin";
let vm;
export default {
    mixins: [commonMixin],
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },
    data() {
        return {
            calendarPlugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
            locale: zhLocale,
            allow(para) {
                return (para.start.getDate() == para.end.getDate() && para.start > new Date())
            },
            slotLabelFormat: {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
            },
            eventTimeFormat: {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
            },
            data: [],
            single: {},
            view_mode: false,
        }
    },
    computed: {
        course() {
            return this.single.course ? this.single.course : {};
        },
        customButtons() {
            const cust = {
                newMeeting: {
                    icon: 'el-icon el-icon-plus',
                    click() {
                        vm.goNew();
                    }
                },
                goList: {
                    icon: 'el-icon el-icon-tickets',
                    click() {
                        vm.goList();
                    }
                },
            };
            if (this.preset.app.create_meeting_forbidden && this.user.role_level < 3) {
                delete cust.newMeeting;
            }
            return cust;
        }
    },
    methods: {
        goNew() {
            this.$router.push('/new');
        },
        goList() {
            this.$router.push('/my-meeting');
        },
        reload() {
            const month = 1;
            this.$api('User.Calendar.My', {month: month}, 1).then((res) => {
                this.evnets = res.data;
            });
        },
        loadEvents(fetchInfo, successCallback) {
            this.$api('User.Calendar.My', {
                start: fetchInfo.start.Format('yyyy-MM-dd'),
                end: fetchInfo.end.Format('yyyy-MM-dd')
            }, 1).then((res) => {
                this.data = res.data.data;
                successCallback(res.data.data);
            });
        },
        handleEventClick(eventInfo) {
            const id = eventInfo.event.id;
            this.$api('User.Calendar.get', {id: id}, 1).then((res) => {
                this.single = res.data.data;
                this.view_mode = true;
            });
        },
        handleSelect(e) {
            // 如果设置了普通用户不可以建立会议，则判断一下。
            if (this.preset.app.create_meeting_forbidden && this.user.role_level < 3) return;
            // 点击单个日历的格子，不提示，直接返回。
            if (Math.floor((e.end - e.start)/60000) < 30) return;

            const ask = "需要预约" + e.start.Format('yyyy-MM-dd hh:mm-') + e.end.Format('hh:mm') + '的会议吗?';
            this.$affirm(ask).then(() => {
                vm.$router.push({name: '新建会议', params: {start: e.start, end: e.end}});
            });
        },
        startMeeting() {
            this.$api('Meeting.Host', {id: this.single.id, review: true}, true).then(res => {
                let host_url = res.data.data.host_url;
                if (this.$isMobile()) {
                    window.location.href = host_url;
                } else {
                    window.open(host_url, '_blank');
                }
                this.view_mode = false;

                this.view_mode = false;
            });
        },
        mailAttendees() {
            let vm = this;
            this.$api('Meeting.Mail.Attendee', {id: this.single.id}, true).then(() => {
                vm.$notice.success("邮件已经发送给参会者!");
            });
        },
        handleDelete(){
            this.$api('Meeting.Delete', {id: this.single.id}, true).then(() => {
                vm.$notice.success("会议已经被删除");
                vm.view_mode = false;
                const api = vm.$refs['fullCalendar'].getApi();
                api.refetchEvents()
            });
        },

        handlePoll(single) {
            let vm = this;
            //this.view_mode = false;
            this.$api('Meeting.Poll',{id:single.id},true).then((res)=>{
                vm.single = Object.assign({selected:Object.keys(res.data.data.single.polls)},res.data.data.single);
                vm.polls = res.data.data.polls;
                this.poll_view = true;
            });
        },
        handleUpdate(single){
            this.single = this.$set(this,'single',single);
            const vm=this;
            this.$api('Meeting.UpdatePoll',single,true).then(()=>{
                vm.$notice.success('更新完成!');
                vm.poll_view = false;
                vm.view_mode = false;
            });
        },
    },
    created() {
        vm = this;
    }
}
